// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"2440786b","314":"f853a26d","349":"27f37650"}[chunkId] + ".chunk.css";
};